import Head from 'next/head';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function Cookiepolicy() {
  return (
    <div>
      <Head>
        <title>Lindle Cookie Policy</title>
        <meta name="description" content="All your links, All at once, All in one place!" />
        <link rel="icon" href="/favicon.ico" />

        {/* Facebook */}
        <meta property="og:title" content="Lindle" />
        <meta property="og:description" content="All your links, All at once, All in one place!" />
        <meta property="og:image" content="/logoText.png" />
        <meta property="og:url" content="https://lindle.vercel.app" />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content="Lindle" />
        <meta name="twitter:description" content="All your links, All at once, All in one place!" />
        <meta name="twitter:image" content="/logoText.png" />
        <meta name="twitter:card" content="/bannerText.png" />

        {/* pinterest */}
        <meta name="pinterest-rich-pin" content="true" />
      </Head>


      {/* Navigation */}
      <Navigation />

      {/* Main Content Section */}
      <main className="container mx-auto my-8 p-8 bg-white shadow-lg rounded-lg">

        {/* Content Heading */}
        <h1 className="text-3xl font-bold mb-6">Cookie Policy for Lindle Website</h1>

        {/* Introduction Section */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">1. Introduction</h2>
          <p>
            Welcome to Lindle! This Cookie Policy explains how Lindle (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) uses cookies on our website. By continuing to browse our site, you agree to the use of cookies as described in this policy.
          </p>
        </section>

        {/* What Are Cookies Section */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">2. What Are Cookies?</h2>
          <p>
            Cookies are small text files that are stored on your device when you visit a website. They are widely used to make websites work more efficiently and provide a better browsing experience.
          </p>
        </section>

        {/* How We Use Cookies Section */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">3. How We Use Cookies</h2>
          <p>
            We use cookies for various purposes, including essential functionalities, performance and analytics, functionality enhancements, and targeted advertising.
          </p>
        </section>

        {/* Types of Cookies Section */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">4. Types of Cookies We Use</h2>
          <p>
            We use both session and persistent cookies to tailor your browsing experience. Session cookies are temporary and erased when you close your browser, while persistent cookies remain on your device for a longer period.
          </p>
        </section>

        {/* Third-Party Cookies Section */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">5. Third-Party Cookies</h2>
          <p>
            Lindle may use third-party services that place their own cookies on your device. Please review the respective privacy policies of these third parties for more information.
          </p>
        </section>

        {/* How to Control Cookies Section */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">6. How to Control Cookies</h2>
          <p>
            You can control and manage cookies in your browser settings. Please note that blocking cookies may affect your experience on our website.
          </p>
        </section>

        {/* Updates to Our Cookie Policy Section */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">7. Updates to Our Cookie Policy</h2>
          <p>
            We may update this Cookie Policy to reflect changes in our practices or for legal reasons. Any updates will be posted on this page, and the date of the last update will be modified accordingly.
          </p>
        </section>

        {/* Contact Information Section */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">8. Contact Information</h2>
          <p>
            If you have any questions or concerns about our use of cookies, please contact us at [insert contact information].
          </p>
        </section>

      </main>

      <Footer />
    </div>
  )
}

export default Cookiepolicy